

<body>
    <main id="wrapper">
        <header>
            <div class="container-fluid">
                <div class="navWrap">
                    <div class="linksWrap">
                        <div class="logo">
                            <a href="index.html"><img src="./assets/images/logo.png" alt="Bajaj Life"
                                    title="Bajaj Life" /></a>
                        </div>
                    </div>
                </div>
            </div>
        </header>
        
        <div class="container">
        <section class="registration">
            <div class="successRow d-none">
                <img src="./assets/images/illustration.png" class="img-fluid">
                <div class="contentRow">
                    <div class="d-flex align-items-center justify-content-center gap-md-4 justify-content-md-start">
                        <img src="./assets/images/success.png" class="img-fluid disp-desktop">
                        <h3>Congratulations ! Your Registration Process is Successfully Completed</h3>
                    </div>
                    <div class="infoRow">
                        <div class="d-flex align-items-start justify-content-between gap-5 mb-3">
                            <p>Customer Reference No:
                                <br><span>(Policy No/Application No/Unique Code)</span></p>
                            <p>0585626290</p>    
                        </div>
                        <div class="d-flex align-items-start justify-content-between gap-5">
                            <p>Reference Code</p>
                            <p>279822217</p>    
                        </div>
                    </div>
                    <div class="buttonGroup">
                        <p class="note"><strong>Note:</strong> Kindly keep a note of the Application No / Policy No and Reference Code</p>
                        <button type="submit" class="btn btn-orange m-auto rounded-3 mt-4">Done</button>
                    </div>
                </div>
            </div>
            <div class="failRow ">
                <img src="./assets/images/fail.png" class="img-fluid">
                <div class="contentRow">
                    <div class="d-flex align-items-center justify-content-center gap-md-4 justify-content-md-start">
                        
                        <h3>Your Registration Process Was Unsuccessful</h3>
                    </div>
                    <div class="infoRow">
                        <div class="d-flex align-items-start justify-content-start gap-5 mb-3">
                            <p>Payment ID</p>
                            <p>{{errorMsg.error.metadata.payment_id}}</p>    
                        </div>
                        <div class="d-flex align-items-start justify-content-start gap-5 mb-3">
                            <p>Reason</p>
                            <p>{{errorMsg.error.reason}}</p>    
                        </div>
                        <div class="d-flex align-items-start justify-content-start gap-5 mb-3">
                            <p>Description</p>
                            <p>{{errorMsg.error.description}}</p>    
                        </div>
                        <div class="d-flex align-items-start justify-content-start gap-5">
                            <p>What Next</p>
                            <p>Please  click on Retry with different Bank Account to proceed with  registration from alternate Bank account. Or you may retry with other  mode of registration.</p>    
                        </div>
                    </div>
                    <div class="buttonGroup d-flex justify-content-center gap-5">
                        <button type="submit" class="btn btn-orange rounded-4 mt-4"  (click)="Retry()">RETRY</button>
                        <button type="submit" class="btn btn-orange white rounded-4 mt-4">CANCEL</button>
                    </div>
                </div>
            </div>
        </section>
        <footer class="d-flex align-items-center justify-content-between flex-md-row flex-column">
           
                    <div class="tollFree d-flex align-items-center justify-content-start gap-4">
                        <img src="./assets/images/call.png" class="img-fluid">
                        <div>
                            <p>Toll Free Number</p>
                            <h4>1800 209 7272</h4>
                        </div>
                    </div>
                    <div class="tollFree d-flex align-items-center justify-content-start gap-4">
                        <img src="./assets/images/whatsapp.png" class="img-fluid">
                        <div>
                            <p>Say Hi to us on our WhatsApp number </p>
                            <h4>+91 88067 27272</h4>
                        </div>
                    </div> 
                    <div class="tollFree d-flex align-items-center justify-content-md-start justify-content-center gap-2">
                        <div>
                            <span>Scan the QR to avail our Digital Services</span>
                        </div>
                        <img src="./assets/images/QR.png" class="img-fluid">
                    </div>    
        </footer>
        
    </div>
    </main>
    
</body>
